// @flow
import { format, addDays, eachDay, isMonday, isWednesday } from "date-fns"

export const getUpcomingWebinars = (): Array<WebinarDate> => {
  // The next 12 days
  const upcomingDays = eachDay(addDays(new Date(), 1), addDays(new Date(), 11))
  // initialize empty array of upcoming webinars
  let upcomingWebinars = []
  // Find mondays and wednesdays
  upcomingDays.map(day => {
    if (isMonday(day) || isWednesday(day)) {
      // Create object with properly formatted value and label
      const webinarDate = {
        value: format(day, "MMM D, YYYY [10:00 AM PT]"),
        label: format(day, "ddd, MMM D, YYYY [10:00 AM - 11:00 AM PDT]"),
      }
      // Add object to upcomingWebinars array
      upcomingWebinars.push(webinarDate)
    }
  })
  // return upcomingWebinars array
  return upcomingWebinars
}



// WEBPACK FOOTER //
// ./src/utils/dates.js